import React, {useState} from "react"
import ReactJson from "react-json-view"
import {BillEvent, getBillEventId, getBillEventKey} from "../../resources/bills"
import {DataTable, DataTableBody, DataTableCell, DataTableHead, DataTableRow} from "../DataTable/DataTable"
import {DataTableActionHeader, DataTableCard} from "../DataTable/DataTable"
import Drawer from "../Drawer/Drawer"
import {BillEventRow} from "./BillEventRow"

interface BillEventsTableProps {
	events: BillEvent[]
}

export function BillEventsTable({events}: BillEventsTableProps) {
	const [selectedEvent, setSelectedEvent] = useState<BillEvent | null>(null)
	const [isEventDrawerOpen, setIsEventDrawerOpen] = useState(false)

	const toggleEventDrawer = (event?: BillEvent) => {
		if (event) {
			setSelectedEvent(event)
		}
		setIsEventDrawerOpen((prevState) => !prevState)
	}

	return (
		<DataTableCard className="bill-events-card">
			<DataTableActionHeader title="Bill Events" enableSticky={false} />
			<DataTable isEmpty={events.length === 0} fullHeight={false} noContentText="No bill events found">
				<DataTableHead>
					<DataTableRow>
						<DataTableCell>Id</DataTableCell>
						<DataTableCell>Bill Event Type</DataTableCell>
						<DataTableCell className="bill-event-payload-cell">Payload</DataTableCell>
						<DataTableCell>Account</DataTableCell>
						<DataTableCell>Payment</DataTableCell>
						<DataTableCell>Transaction</DataTableCell>
					</DataTableRow>
				</DataTableHead>
				<DataTableBody>
					{events.map((event, index) => (
						<BillEventRow key={getBillEventKey(event, index)} event={event} onClick={() => toggleEventDrawer(event)} />
					))}
				</DataTableBody>
			</DataTable>
			{selectedEvent && (
				<Drawer
					open={isEventDrawerOpen}
					onClose={() => toggleEventDrawer()}
					direction="right"
					className="event-side-drawer"
					title={`Bill Event ${getBillEventId(selectedEvent)}`}
				>
					{isEventDrawerOpen && (
						<div className="p-4" style={{width: 800}}>
							<ReactJson name={"data"} src={selectedEvent} />
						</div>
					)}
				</Drawer>
			)}
		</DataTableCard>
	)
}
